import { FC } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../../redux/app/hooks';
import { RootState } from '../../../../../redux/app/store';
import { updateBucket } from '../../../../../redux/features/buckets/BucketsSlice';
import { BucketItem, BucketType } from '../../../../../redux/features/buckets/BucketsState';
import { resetIntelligentFilteringMessage } from '../../../../../redux/features/conversations/conversationsSlice';
import { getIcon } from '../../../../utils/DocumentUtils';
import { BucketCheckbox } from './BucketCheckbox';

export interface IBucketsTreeViewProps {
    chatId: string;
    items: BucketItem[];
    collapseParents?: boolean;
}

export const BucketsTreeView: FC<IBucketsTreeViewProps> = ({ items, collapseParents, chatId }) => {
    const { Buckets } = useAppSelector((state: RootState) => state.buckets);
    const dispatch = useAppDispatch();

    const handleOnChange = (checked: boolean, treeData: BucketItem) => {
        const bucketItem = Buckets.find((d) => d.id === treeData.id);

        if (bucketItem) {
            dispatch(resetIntelligentFilteringMessage({ chatId }));
            dispatch(updateBucket({ ...bucketItem, selected: checked }));
        }
    };

    return (
        <div className="mt-2 max-h-[450px] overflow-y-auto">
            {Buckets.length > 0 && (
                <ul className="menu xl:menu-vertical bg-slate-100 lg:min-w-max dark:bg-slate-900 dark:text-slate-300 rounded-box rounded-lg padding-20">
                    {items
                        .filter((b) => b.type === BucketType.Bucket)
                        .map((bucket, i) => (
                            <li key={`bucket-item-${i}`}>
                                <details open={collapseParents} onClick={(e) => e.stopPropagation()}>
                                    <summary onClick={(e) => e.stopPropagation()}>
                                        <BucketCheckbox
                                            title={bucket.title}
                                            checked={bucket.selected || false}
                                            key={`${i}`}
                                            icon={getIcon('')}
                                            onChange={(checked: boolean) => {
                                                handleOnChange(checked, bucket);
                                            }}
                                        />
                                    </summary>
                                    {items.filter((b) => b?.parent?.id === bucket.id).length > 0 && (
                                        <ul key={`b-${i}`}>
                                            {items
                                                .filter((b) => b?.parent?.id === bucket.id)
                                                .map((bucketSource, index) => (
                                                    <li key={`${index}`}>
                                                        <BucketCheckbox
                                                            title={bucketSource.title}
                                                            checked={bucketSource.selected || false}
                                                            icon={getIcon(bucketSource.documentType)}
                                                            onChange={(checked: boolean) =>
                                                                handleOnChange(checked, bucketSource)
                                                            }
                                                        />
                                                    </li>
                                                ))}
                                        </ul>
                                    )}
                                </details>
                            </li>
                        ))}
                </ul>
            )}
        </div>
    );
};
